import React from 'react';
import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';
import { Tab, Tabs, Box, makeStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import PATHS from 'constants/paths';

const useStyles = makeStyles((theme) => ({
  // Phantom left spacer: mirrors the right menu slot to keep the Tabs centered,
  // but only grows at sm+ where there's room. On xs (phones) it collapses so the
  // right menu keeps its natural width -- otherwise the equal split starves the
  // menu (~half the slack), cramping the icons and overflowing the row.
  leftSpacer: {
    flexBasis: 0,
    flexGrow: 0,
    [theme.breakpoints.up('sm')]: {
      flexGrow: 1,
    },
  },
  // Holds the right menu; grows to fill the slack (pushing the menu to the right
  // on xs, balancing the spacer on sm+). minWidth:0 lets sm+ center symmetrically.
  rightSlot: {
    flexGrow: 1,
    flexBasis: 0,
    minWidth: 0,
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const LinkTab = (props) => {
  return <Tab component={Link} color="primary" {...props} />;
};

const ConversationTabs = ({ tab, rightMenu }) => {
  const { conversationId } = useParams();
  const classes = useStyles();

  return (
    <Box boxShadow={3} display="flex" alignItems="center">
      <div className={classes.leftSpacer} />
      <Tabs value={tab} indicatorColor="primary" textColor="primary" centered>
        <LinkTab
          label={<FormattedMessage id="Bookings" defaultMessage="Bookings" />}
          disabled={tab === 0}
          to={PATHS.conversations.bookings.replace(':conversationId', conversationId)}
        />
        <LinkTab
          label={<FormattedMessage id="Messages" defaultMessage="Messages" />}
          disabled={tab === 1}
          to={PATHS.conversations.read.replace(':conversationId', conversationId)}
        />
      </Tabs>
      <div className={classes.rightSlot}>{rightMenu}</div>
    </Box>
  );
};

ConversationTabs.propTypes = {
  tab: PropTypes.number.isRequired,
  rightMenu: PropTypes.node,
};

export default ConversationTabs;
